import React, { useState } from 'react';
import { product } from './Datatype';

interface cartitem {
  productid: string;
  name: string;
  price: number | string;
  quantity: number;
}

interface props {
  products: product[];
  files: any[];
  addtocart: (product: product) => void;
  openview: (product: product) => void;
  cartitems: cartitem[];
  updatequantity: (productid: string, delta: number) => void;
  removefromcart: (productid: string) => void;
}

const stepbtn: React.CSSProperties = { width: '28px', height: '28px', border: '1px solid var(--rule)', borderRadius: '4px', background: '#F7F9FB', cursor: 'pointer', font: 'inherit' };

const ProductThumbnailCarousel: React.FC<{ files: any[] }> = ({ files }) => {
  const [activeindex, setactiveindex] = useState(0);

  if (!files || files.length === 0) {
    return (
      <div style={{ height: '220px', background: '#f8f8f8', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999', fontSize: '13px' }}>
        no image
      </div>
    );
  }

  const prev = (e: React.MouseEvent) => {
    e.stopPropagation();
    setactiveindex((activeindex - 1 + files.length) % files.length);
  };

  const next = (e: React.MouseEvent) => {
    e.stopPropagation();
    setactiveindex((activeindex + 1) % files.length);
  };

  return (
    <div style={{ position: 'relative', width: '100%', height: '220px', overflow: 'hidden', background: '#fff' }}>
      <img
        src={`/file?_fileid=${files[activeindex]._id}&_adminuserid=${window.APPSETTING.adminuserid}`}
        alt="thumbnail"
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
      />
      {files.length > 1 && (
        <>
          <button
            type="button"
            onClick={prev}
            style={{ position: 'absolute', top: '50%', left: '8px', transform: 'translateY(-50%)', background: 'rgba(255,255,255,0.85)', border: '1px solid #ccc', borderRadius: '50%', width: '28px', height: '28px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            &#10094;
          </button>
          <button
            type="button"
            onClick={next}
            style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)', background: 'rgba(255,255,255,0.85)', border: '1px solid #ccc', borderRadius: '50%', width: '28px', height: '28px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            &#10095;
          </button>
        </>
      )}
    </div>
  );
};

const ShopTable: React.FC<props> = ({ products, files, addtocart, openview, cartitems, updatequantity, removefromcart }) => {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '20px', marginTop: '16px' }}>
      {products.map((item) => {
        const line = cartitems.find((c) => c.productid === item._id);
        return (
        <div 
          key={item._id} 
          onClick={() => openview(item)}
          style={{ 
            background: '#ffffff', 
            border: '1px solid #e2e8f0', 
            borderRadius: '6px', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'space-between', 
            padding: '16px', 
            cursor: 'pointer',
            transition: 'box-shadow 0.2s ease',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
          }}
          onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 6px 14px rgba(0,0,0,0.08)')}
          onMouseLeave={(e) => (e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)')}
        >
          <div>
            <ProductThumbnailCarousel files={files.filter(f => f._productid === item._id)} />
            
            <h4 style={{ margin: '12px 0 6px 0', fontSize: '1.05rem', color: '#0A1118' }}>
              {item.name}
            </h4>
            
            <p style={{ margin: '0 0 12px 0', color: '#718096', fontSize: '0.85rem', lineHeight: '1.4' }}>
              {item.description}
            </p>
          </div>

          <div>
            <div style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#0A1118', marginBottom: '12px' }}>
               ₹{item.price}
            </div>

            {line ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                <button type="button" className="btn-small" style={stepbtn} onClick={(e) => { e.stopPropagation(); line.quantity > 1 ? updatequantity(item._id, -1) : removefromcart(item._id); }}>-</button>
                <span style={{ minWidth: '20px', textAlign: 'center', fontWeight: 600 }}>{line.quantity}</span>
                <button type="button" className="btn-small" style={stepbtn} onClick={(e) => { e.stopPropagation(); updatequantity(item._id, 1); }}>+</button>
                <span style={{ fontSize: '0.8rem', color: 'var(--cust-muted)' }}>In your subscription</span>
              </div>
            ) : (
            <button 
              type="button" 
              className="btn-blue full-width" 
              onClick={(e) => {
                e.stopPropagation();
                addtocart(item);
              }}
            >
              Add to Subscription
            </button>
            )}
          </div>
        </div>
        );
      })}
    </div>
  );
};

export default ShopTable;